<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1ChrJF8/tc-custom/9781426874383.jpg?1728259255657" alt="This image is the cover for the book 3rd Secret, The Chapman Files"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">3rd Secret, The Chapman Files
      </h1>
      <p class="bookDescription body article font2">
        <p>Rick Thomas stole drug-cartel evidence from a government facility. And spent three years in a federal prison.<br/><br/>Attorney Erin Morgan has a rule: never defend the bad guys. But Rick Thomas, quiet and self-assured, doesn't <i>seem</i> bad. That's why she agrees to defend him against what he swears is a trumped-up murder charge. She's ignoring her experience and listening to her instincts instead.<br/><br/>But psychologist and expert witness Kelly Chapman is listening to <i>her</i> instincts, too. And they're saying that Rick Thomas is lying to Erin. That he's keeping secrets. That he's a dangerous man. And that, despite everything, maybe he's one of the <i>good</i> guys.<br/><br/></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Tara Taylor Quinn
      </h2>
      
      <p class="authorDescription body article"> Tara Taylor Quinn, is a&#160;<I>USA Today</I>&ndash;bestselling author of one hundred novels, which have been translated into twenty languages and has sold more than seven million copies. Known for her intense emotional fiction, Quinn&rsquo;s novels have received critical acclaim, including the 2008 National Reader&rsquo;s Choice Award, and five RITA Award finalist, and a former president and board director of the Romance Writers of America. She has appeared often on local and national TV, including&#160;<I>CBS Sunday Morning</I>. For additional offers, news, and contests, visit the author at tarataylorquinn.com. </p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?5960a686